import ChipTaskCheckStatus from '@/components/chip/ChipTaskCheckStatus';
import ChipTaskProcessTypeStatus from '@/components/chip/ChipTaskProcessTypeStatus';
import EntityDetailButton from '@/components/entity-detail/components/Button';
import HoverCopyCell from '@/components/table-data-grid/HoverCopyCell';
import { DEFAULT_DISPLAY } from '@/constants/default-value/default-value';
import type { TableColumnConfig } from '@/types/common/table-config.type';
import { RoleEnum } from '@/types/enums/role.enum';
import { dateUtils } from '@/utils/date';
import { t } from '@/utils/lang';

export const columnName = {
    code: 'code',
    codeTicket: 'ticket.code',
    name: 'name',
    customerName: 'ticket.customer.name',
    taskProcessType: 'taskProcessType',
    serialNumberDevice: 'device.serialNumber',
    productName: 'device.name',
    scheduledTime: 'scheduledTime',
    assigneeName: 'assigneeName',
    taskCheckStatus: 'taskCheckStatus',
    taskCheckType: 'taskCheckType.name',
    isLateTaskCheck: 'isLateTaskCheck',
};

export const columns = (columnParams: any): TableColumnConfig[] => [
    {
        field: columnName.code,
        headerName: 'Mã Task',
        minWidth: 70,
        editable: false,
        sortingOrder: ['asc', 'desc'],
        sortable: true,
        renderCell: params => (
            <HoverCopyCell value={params.value}>
                <EntityDetailButton
                    text={params.value}
                    identifier={columnParams?.identifier}
                    entityId={params.row?.id}
                    type='TASK'
                />
            </HoverCopyCell>
        ),
    },
    {
        field: columnName.codeTicket,
        headerName: 'Mã Ticket',
        minWidth: 150,
        renderCell: params => (
            <HoverCopyCell value={params.row?.ticket?.code}>
                <EntityDetailButton
                    text={params.row?.ticket?.code}
                    identifier={columnParams?.identifier}
                    entityId={params.row?.ticket?.id}
                    type='TICKET'
                />
            </HoverCopyCell>
        ),
    },
    {
        field: columnName.name,
        headerName: 'Tên',
        minWidth: 150,
        editable: false,
        sortable: false,
        renderCell: params => <HoverCopyCell value={params.value} />,
    },
    {
        field: columnName.productName,
        headerName: 'Thiết bị',
        minWidth: 200,
        editable: false,
        sortable: false,
        renderCell: params => (
            <HoverCopyCell value={params.row?.device?.name}>
                <EntityDetailButton
                    text={params.row?.device?.name}
                    identifier={columnParams?.identifier}
                    entityId={params.row?.deviceId}
                    type='DEVICE'
                />
            </HoverCopyCell>
        ),
    },
    {
        field: columnName.assigneeName,
        headerName: 'Người thực hiện',
        minWidth: 150,
        flex: 1,
        editable: false,
        sortable: false,
        renderCell: params => (
            <HoverCopyCell value={params.value}>
                <EntityDetailButton
                    text={params.value}
                    identifier={columnParams?.identifier}
                    entityId={params.row?.assigneeId}
                    type='ASSIGNEE'
                />
            </HoverCopyCell>
        ),
        excludeRoles: [RoleEnum.KTV],
    },
    {
        field: columnName.scheduledTime,
        headerName: 'Ngày bắt đầu',
        minWidth: 120,
        editable: false,
        sortingOrder: ['asc', 'desc'],
        sortable: true,
        renderCell: params => (
            <HoverCopyCell value={dateUtils.getDate(params.value)} />
        ),
    },
    {
        field: columnName.taskCheckStatus,
        headerName: 'Trạng thái',
        minWidth: 150,
        editable: false,
        sortable: false,
        renderCell: params => <ChipTaskCheckStatus status={params.value} />,
    },
    {
        field: columnName.customerName,
        headerName: 'Khách hàng',
        minWidth: 150,
        flex: 1,
        editable: false,
        sortable: false,
        renderCell: params => {
            return (
                <HoverCopyCell value={params.row.ticket?.customer?.name}>
                    <EntityDetailButton
                        text={params.row.ticket?.customer?.name}
                        identifier={columnParams?.identifier}
                        entityId={params.row.ticket?.customer?.id}
                        type='CUSTOMER'
                    />
                </HoverCopyCell>
            );
        },
        excludeRoles: [RoleEnum.CUSTOMER],
    },
    {
        field: columnName.taskCheckType,
        headerName: 'Loại',
        minWidth: 120,
        editable: false,
        sortable: false,
        renderCell: params => (
            <HoverCopyCell
                value={
                    params.row?.taskCheckType?.name
                        ? params.row?.taskCheckType?.name
                        : DEFAULT_DISPLAY
                }
            />
        ),
    },
    {
        field: columnName.taskProcessType,
        headerName: 'Loại Task xử lý',
        minWidth: 150,
        editable: false,
        sortable: false,
        renderCell: params => (
            <ChipTaskProcessTypeStatus status={params.value || 'default'} />
        ),
    },
    {
        field: columnName.serialNumberDevice,
        headerName: 'Seri thiết bị',
        minWidth: 100,
        editable: false,
        sortable: false,
        renderCell: params => (
            <HoverCopyCell value={params.row?.device?.serialNumber} />
        ),
    },
    {
        field: columnName.isLateTaskCheck,
        headerName: 'Thời hạn',
        minWidth: 120,
        editable: false,
        sortable: false,
        renderCell: params =>
            params.value
                ? t('Trễ hạn', 'isLateTaskCheck')
                : t('Đúng hạn', 'isLateTaskCheck'),
    },
];
